const API_URL = "https://app.tavad.com/hce/wp-json/wp/v2";

export async function getAllDocumentacion() {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/documentacion?per_page=100`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getDocumentacionByID(postId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/documentacion/${postId}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getAllDocumentacionByTax(taxId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/documentacion?tratamiento=${taxId}&per_page=100`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}